<template>
  <footer>
    <div style="text-align: center;">&copy; {{ currentYear }}   Copyright International Workshop on IDASB&nbsp;&nbsp;&nbsp;</div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date()
    }
  }
}
</script>
